export enum SettingTypeEnum {
    STRING = 'STRING',
    NUMBER = 'NUMBER',
    OBJECT = 'OBJECT',
    BOOLEAN = 'BOOLEAN',

    CARD = 'OBJECT.CARD',
    AVATAR = 'RESOURCE.AVATAR',
    TIMEZONE = 'STRING.TIMEZONE'
}
